import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Skill, SkillUpdate } from "@/model";
import skillRepository from "@/repository/skillRepository";
import { intentQueryKeys } from "@/query/intent";
import { skillQueryKeys } from "./keys";


export const useUpdateSkill = (agentId: number, skillId?: number) => {
    const queryClient = useQueryClient();

    return useMutation<Skill, AxiosError, SkillUpdate>({
        mutationKey: ["skill", 'agent', agentId, "skill", skillId, "update"],
        mutationFn: async (body: SkillUpdate) => {
            try {
                const { data } = await skillRepository.update(agentId, skillId!, body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: skillQueryKeys.all(agentId)
            });
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.intents(agentId, skillId)
            });
        }
    });
};
